import script from "./CalendarMonthGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarMonthGrid.vue?vue&type=script&setup=true&lang=js"

import "./CalendarMonthGrid.vue?vue&type=style&index=0&id=10b58dd8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10b58dd8"]])

export default __exports__